import { Component, OnInit, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SourceMetadata } from "../../models/metadata";
import { ItemConfigBase } from "../../interfaces/iitemconfig";
import { IMetaDataItemDetail } from "../../interfaces/imetadetailitem";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@Component({
    selector: "metadataitemselector",
    templateUrl: "./metadataitemselector.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, TooltipModule, BsDropdownModule]
})
export class MetaDataItemSelector implements OnInit {

    @Input() availableMetaItems: SourceMetadata[];
    @Input() item: ItemConfigBase;
    @Input() editMode: boolean;

    ngOnInit(): void {
        this.item.itemDetail.metadataItemDetails = this.item.itemDetail.metadataItemDetails || [];
        this.item.itemDetail.metadataItemDetails.forEach((m) => {
            const meta: SourceMetadata = this.availableMetaItems.find((i) => {
                return i.id === m.metadataItemId;
            });
            m.name = "";
            m.disabled = false;
            if (meta !== null && meta !== undefined) {
                m.name = meta.name;
                m.disabled = meta.disabled;
            }
        });
    }

    public createMetaItem(item: SourceMetadata): void {
        this.metaChange();
        this.item.itemDetail.metadataItemDetails.push({ metadataItemId: item.id, name: item.name, url: item.url, value: "", disabled: item.disabled });
    }

    public removeMetaItem(item: IMetaDataItemDetail): void {
        this.metaChange();
        const index: number = this.item.itemDetail.metadataItemDetails.indexOf(item);

        if (index !== -1) {
            this.item.itemDetail.metadataItemDetails.splice(index, 1);
        }
    }

    public metaChange(): void {
        this.item.itemDetail.modified = true;
    }

}
